export default __webpack_public_path__ + "static/18-3f3e5624bbd9fc79847dcaf3a3a84568.jpg";